import { toStringBigDecimal } from '@0xtorch/big-decimal'
import type { Action } from '@0xtorch/core'
import { and, eq } from 'drizzle-orm'
import { actionTransferTable } from '../../schema'
import type { DatabaseWithTransaction } from '../../types'
import { deleteAssistantProposalsForActionIds } from './deleteAssistantProposalsForActionKeys'

type UpdateActionTransferPricesParameters = {
  actions: Action[]
  database: DatabaseWithTransaction
}

/** price が定義されている　Action Transfer を更新する */
export const updateActionTransferPrices = async ({
  actions,
  database: { transaction },
}: UpdateActionTransferPricesParameters) => {
  const updatingData: { actionId: string; order: number; price: string }[] = []
  for (const action of actions) {
    for (const [order, transfer] of action.transfers.entries()) {
      if (transfer.price === undefined) {
        continue
      }
      updatingData.push({
        actionId: `${action.source}_${action.order}`,
        order,
        price: toStringBigDecimal(transfer.price),
      })
    }
  }
  await transaction([
    (tx) => [
      deleteAssistantProposalsForActionIds({
        database: tx,
        actionIds: [...new Set(updatingData.map((data) => data.actionId))],
      }),
    ],
    (tx) => [
      ...updatingData.map((data) =>
        tx
          .update(actionTransferTable)
          .set({ price: data.price })
          .where(
            and(
              eq(actionTransferTable.actionId, data.actionId),
              eq(actionTransferTable.order, data.order),
            ),
          ),
      ),
    ],
  ])
}
